import { render, staticRenderFns } from "./RflmQuestionnaire.vue?vue&type=template&id=2296697c"
import script from "./RflmQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./RflmQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./RflmQuestionnaire.vue?vue&type=style&index=0&id=2296697c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports